<template>
  <div>
    <a-modal
      :title="$t(`tips.tip81`)"
      centered
      :visible="showModal"
      :cancelText="$t(`button.cancel`)"
      :okText="$t(`button.confirm`)"
      @cancel="handleCancel"
      @ok="getPhoneCode"
    >
      <div class="verify-box">
        <img :src="verifyInfo.image" alt="" />
        <div @click="getCodeVerify" style="cursor: pointer">
          {{ $t(`tips.tip82`) }}
        </div>
      </div>
      <div>
        <a-input v-model:value="verify_code" :placeholder="$t(`tips.tip8`)" />
      </div>
    </a-modal>
  </div>
</template>
<script>
import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  reactive,
  watch,
  ref,
  toRefs,
  nextTick,
} from "vue";
import { getSign } from "@/utils/signature";
export default defineComponent({
  setup(props, context) {
    const { proxy } = getCurrentInstance();
    let globalProperties =
      getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axios;
    const state = reactive({
      showModal: false,
      appId: "a0f0e723-f2bb-11e8-bc50-00163e0c395e",
      appKey: "a0f12ce4-f2bb-11e8-bc50-00163e0c395e",
      verifyInfo: {},
      verify_code: "",
      smsType: ''
    });
    const showDia = (smsType) => {
      state.showModal = true;
      state.smsType = smsType
      getCodeVerify();
    };

    //获取验证码图片码
    const getCodeVerify = () => {
      let param = {
        timestamp: Date.parse(new Date()) / 1000,
        fun: "getCodeVerify",
        requestType: "User",
        appId: state.appId,
        appKey: state.appKey,
        smsType: state.smsType,
      };
      var signature = getSign(param);
      var obj = JSON.parse(JSON.stringify(param));
      obj.signature = signature;
      axios("/api/apiservice/apiroute", obj).then((res) => {
        state.verifyInfo = res;
      });
    };

    const getPhoneCode = () => {
      context.emit("send", state.verify_code, state.verifyInfo.session_id);
      handleCancel();
    };

    const handleCancel = () => {
      state.showModal = false;
      state.verify_code = "";
      state.smsType = "";
    };

    return {
      ...toRefs(state),
      showDia,
      handleCancel,
      getPhoneCode,
      getCodeVerify,
    };
  },
});
</script>
<style scoped>
.verify-box {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 20px;
}
.verify-box img {
  width: 45%;
  margin-right: 30px;
}
</style>
